import { MessageCircle } from "lucide-react";
import { CONTACT } from "@/lib/api";
import { waLink } from "@/lib/catalog";
import { track } from "@/lib/analytics";

export const WA_DEFAULT = "Hello SwayamScale, I visited your website and would like to know more about your digital business services.";
export const waFor = (item) => waLink(CONTACT.phone, item ? `Hello SwayamScale, I visited your website and would like to know more about ${item}.` : WA_DEFAULT);

export const FloatingWhatsApp = () => (
  <a href={waFor()} target="_blank" rel="noopener noreferrer" aria-label="Chat with SwayamScale on WhatsApp"
    onClick={() => track("whatsapp_click", { location: "floating_button" })}
    data-testid="floating-whatsapp-button"
    className="fixed bottom-5 left-5 z-[55] flex items-center gap-2 rounded-full bg-[#25D366] p-3.5 text-[#05301A] shadow-[0_10px_40px_-10px_rgba(37,211,102,0.7)] transition-transform hover:scale-105 sm:px-5">
    <MessageCircle className="h-6 w-6" />
    <span className="hidden text-sm font-semibold sm:inline">Chat on WhatsApp</span>
  </a>
);
